// 推荐产品
document.addEventListener("DOMContentLoaded", function() {
  $(document).on("click", "#fbt-show-btn", function() {
    if($(".tw-purchase-together").length) {
        $(".horizontal-product-list").toggleClass("active");
    }
  });
});

// 产品详情页折扣码
  if (!customElements.get('discount-code')) {
    class DiscountCode extends HTMLElement {
      constructor() {
        super();
        this.discountCode = this.querySelector('.js-discount-code');
        this.discountCodeBtn = this.querySelector('.js-copy-button');
        this.copySuccess = this.querySelector('.js-copy-success');
        this.init();
      }

      init() {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          this.discountCodeBtn.addEventListener('click', this.copyCode.bind(this));
          this.discountCode.addEventListener('click', this.copyCode.bind(this));
        } else {
          this.discountCodeBtn.hidden = true;
        }
      }

      copyCode() {
        const discountCode = this.discountCode.textContent.trim();
        navigator.clipboard.writeText(discountCode).then(() => {
          if (!this.copySuccess) return;

          this.copySuccess.style.visibility = 'visible';
          this.copySuccess.style.opacity = '1';
          this.copySuccess.setAttribute('aria-hidden', 'false');

          setTimeout(() => {
            this.copySuccess.style.visibility = 'hidden';
            this.copySuccess.style.opacity = '0';
          }, 2000);
        });
      }
    }

    customElements.define('discount-code', DiscountCode);
  }

  (function () {
  'use strict';

  const OLD_PATH = '/blogs/news';
  const NEW_PATH = '/blogs/ebike';

  function replaceBlogLinks(root = document) {
    const links = root.querySelectorAll(
      'a[href*="/blogs/news"]'
    );

    links.forEach(function (link) {
      const href = link.getAttribute('href');

      if (!href) return;

      const newHref = href.replace(
        OLD_PATH,
        NEW_PATH
      );

      if (newHref !== href) {
        link.setAttribute('href', newHref);
      }
    });
  }

  function init() {
    replaceBlogLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();